import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function myAwaitingPaymentJobsReducer(state = initialState.myAwaitingPaymentJobs, action) {
  switch (action.type) {
    case types.LOAD_MY_AWAITING_PAYMENT_JOBS_SUCCESS:
      return action.myAwaitingPaymentJobs;

    default:
      return state;
  }
}
